// --- SVG Component for GoHighLevel ---
export const GoHighLevel = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`lucide lucide-go-high-level ${className}`}
      {...props}
    >
      <path d="M5 22V7" />
      <path d="M5 7l-3 3" />
      <path d="M5 7l3 3" />
      <path d="M12 22V13" />
      <path d="M12 13l-3 3" />
      <path d="M12 13l3 3" />
      <path d="M19 22V7" />
      <path d="M19 7l-3 3" />
      <path d="M19 7l3 3" />
    </svg>
  );
};